import { FC } from "react";
import { IconProps } from "./types";

type SearchProps =
  | {
      type: "icon-20";
      width: 20;
      height: 20;
    }
  | {
      type: "icon-28";
      width: 28;
      height: 28;
    }
  | { type: "icon-search-bar"; width: 20; height: 20 };

export const Search: FC<IconProps & SearchProps> = ({
  className,
  type = "icon-20",
  width = 20,
  height = 20,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox={`0 0 ${width} ${width}`}
      className={className}
      {...props}
    >
      {type === "icon-20" && (
        <path
          fill="#fff"
          d="M7.8 14.4a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13zM19 18.1l-4.8-4.8a.4.4 0 0 0-.3-.1h-.4a7.6 7.6 0 1 0-.4.4v.4l.1.3L18 19a.4.4 0 0 0 .6 0l.4-.4a.4.4 0 0 0 0-.6z"
        />
      )}
      {type === "icon-28" && (
        <path
          fill="#111"
          d="M12.05 18.954a6.905 6.905 0 0 1-3.844-1.17 6.933 6.933 0 0 1-2.548-3.112 6.955 6.955 0 0 1 1.5-7.56 6.9 6.9 0 0 1 7.54-1.504 6.922 6.922 0 0 1 3.104 2.555 6.95 6.95 0 0 1 .64 6.51 6.931 6.931 0 0 1-3.744 3.754c-.84.349-1.74.528-2.648.527zM23.86 22.8l-5.07-5.085a.467.467 0 0 0-.334-.138h-.405a8.12 8.12 0 0 0-.392-11.343A8.073 8.073 0 0 0 6.342 6.4 8.119 8.119 0 0 0 4 12.064a8.119 8.119 0 0 0 2.28 5.687 8.072 8.072 0 0 0 11.315.29v.4c.002.126.051.246.139.335l5.07 5.085a.472.472 0 0 0 .669 0l.388-.39a.471.471 0 0 0 .103-.516.47.47 0 0 0-.103-.154z"
        />
      )}
      {type === "icon-search-bar" && (
        <path
          fill="#111"
          d="M8 0C12.4183 0 16 3.58172 16 8C16 10.0292 15.2421 11.8797 13.9971 13.29L19.8535 19.1465C20.0488 19.3417 20.0488 19.6583 19.8535 19.8535C19.6583 20.0488 19.3417 20.0488 19.1465 19.8535L13.29 13.9971C11.8797 15.2421 10.0292 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1Z"
        />
      )}
    </svg>
  );
};
